module.exports = __webpack_public_path__ + "static/bottegaportfolio-909f408a344f107f64eecd8be8d49ca4.jpg";